var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"mb-5 font-11px\" *ngFor=\"let warning of warnings\"\u003E{{ \"DFU.PREREQUISITES.\" + warning | translate:translateParams }}\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;